import React from 'react'
import WrapperLoader from '../loader/WrapperLoader'
import SimplePieChart from './SimplePieChart'

const CustomPieChart = ({ data, title, subtitle, loading }) => {
  return (
    <WrapperLoader loading={loading}>
      <div className="dashboard-tile">
        <div className="legend">
          <div className="bold">{title}</div>
          <div>{subtitle}</div>
        </div>
        <SimplePieChart data={data} />
      </div>
    </WrapperLoader>
  )
}

export default CustomPieChart
